export const SUPPORTERS_LOADING = "SUPPORTERS_LOADING";
export const SUPPORTERS_SUCCESS = "SUPPORTERS_SUCCESS";
export const SUPPORTERS_ERROR = "SUPPORTERS_ERROR";

export const SUPPORTERS_IMPORTED = "SUPPORTERS_IMPORTED";
export const SUPPORTERS_IMPORT_ERROR = "SUPPORTERS_IMPORT_ERROR";

export const FLAGGED_SUPPORTERS_LOADING = "FLAGGED_SUPPORTERS_LOADING";
export const FLAGGED_SUPPORTERS_SUCCESS = "FLAGGED_SUPPORTERS_SUCCESS";
export const FLAGGED_SUPPORTERS_ERROR = "FLAGGED_SUPPORTERS_ERROR";